import 'twin.macro';
import { useAtomValue } from 'jotai';

import CandidateReferenceItem from './candidate-reference-item';
import { selectedJobApplicationAtom } from '../../../../../job-listing/employer-job-listing.atoms';
import { useMemo } from 'react';

function CandidateReferencesSection() {
  const selectedJobApplication = useAtomValue(selectedJobApplicationAtom);

  const sortedReferences = useMemo(
    () =>
      selectedJobApplication?.worker?.worker_references?.sort((a, b) => {
        const dateA = new Date(a.inserted_at).getTime();
        const dateB = new Date(b.inserted_at).getTime();
        return dateB - dateA;
      }) ?? [],
    [selectedJobApplication?.worker?.worker_references]
  );

  return (
    <div tw="flex flex-col gap-3">
      {sortedReferences?.map((reference) => (
        <CandidateReferenceItem key={reference.id} reference={reference} />
      ))}
    </div>
  );
}
export default CandidateReferencesSection;
